import React from "react";
import "./Msalarydecelerction.css";
import DescriptionIcon from "@mui/icons-material/Description";

export default function TaxRegimeCards() {
  return (
    <div className="tax-wrapper">
      {/* OLD TAX */}
      <div className="tax-card">
        <DescriptionIcon className="tax-icon" />
        <h2 className="tax-title">Old Tax Regime</h2>

        <div className="tax-table">
          <div className="tax-table-head">
            <span>Components</span>
            <span>Monthly</span>
          </div>

          <div className="tax-row">
            <span>Basic Salary</span>
            <span>₹30,000</span>
          </div>
          <div className="tax-row">
            <span>HRA</span>
            <span>₹10,000</span>
          </div>
          <div className="tax-row">
            <span>Other Allowances</span>
            <span>₹5,000</span>
          </div>
        </div>
      </div>

      {/* NEW TAX */}
      <div className="tax-card">
        <DescriptionIcon className="tax-icon" />
        <h2 className="tax-title">New Tax Regime</h2>

        <div className="tax-table">
          <div className="tax-table-head">
            <span>Components</span>
            <span>Monthly</span>
          </div>

          <div className="tax-row">
            <span>Basic Salary</span>
            <span>₹28,000</span>
          </div>
          <div className="tax-row">
            <span>HRA</span>
            <span>₹12,000</span>
          </div>
          <div className="tax-row">
            <span>Other Allowances</span>
            <span>₹6,000</span>
          </div>
        </div>
      </div>
    </div>
  );
}
